import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import axiosMain from "../../../http/axios/axios_main";
import { fetchUserRightsRequest } from "../../../store/actions";
//import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
function RefundStatus() {
  const tableRef = useRef(null);
  //const { auctionCenterId } = useAuctionDetail();
  //const userCode = atob(sessionStorage.getItem("argument4")); //const dispatch = useDispatch();
  const { refundId, auctionCenterId } = useParams();
  const [openingBalance, setOpeningBalance] = useState("");
  const [responseData, setResponseData] = useState(null);
  const FactoryModalClose = () => setFactoryCreate(false);
  const [FactoryCreate, setFactoryCreate] = useState(true);

  useEffect(() => {
    axiosMain
      .get(`/postauction/allocateFund/getbuyerBalance/${auctionCenterId}`)
      .then((response) => {
        // console.log(response.data.responseData);
        setOpeningBalance(response.data.responseData);
      })
      .catch((error) => {
        //console.error("Error fetching buyer balance:", error);
      });
  }, []);

  localStorage.setItem("auctionCenterId", btoa(auctionCenterId));
  console.log("userid", atob(localStorage.getItem("argument2")));
  const dispatch = useDispatch();

  dispatch(
    fetchUserRightsRequest(
      auctionCenterId,
      atob(localStorage.getItem("argument2"))
    )
  );
  useEffect(() => {
    fetchData();
  }, [refundId]);

  const getStatusMessage = (status) => {
    //100 = Successful, 101 = PG-Trans-Failed, 102 = Wallet-Bal-Trans-Failed, 103 = Cancelled/Aborted
    switch (status) {
      case "100":
        return "Successful";
      case "101":
        return "PG-Trans-Failed";
      case "102":
        return "Wallet-Bal-Trans-Failed";
      case "103":
        return "Cancelled /Aborted";
      default:
        return "";
    }
  };
  const fetchData = async () => {
    try {
      const { data } = await axiosMain.get(
        `/postauction/allocateFund/getRefundDetailsAfterRedirect/${refundId}`
      );
      setResponseData(data.responseData);
    } catch (error) {
      console.error("Failed to fetch payment details:", error);
      FactoryModalClose();
    }
  };

  const formatDate = (dateTimeString) => {
    const dateTime = new Date(dateTimeString);
    const pad = (num) => num.toString().padStart(2, "0");
    return `${pad(dateTime.getDate())}/${pad(
      dateTime.getMonth() + 1
    )}/${dateTime.getFullYear()} ${pad(dateTime.getHours())}:${pad(
      dateTime.getMinutes()
    )}:${pad(dateTime.getSeconds())}`;
  };

  return (
    <>
      <div id="pdfContent">
        <Modal
          show={FactoryCreate}
          onHide={FactoryModalClose}
          size="md"
          centered
          style={{ border: "1px solid #ccc" }}
        >
          <Modal.Header>
            <Modal.Title>Refund Request Status</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={() => FactoryModalClose()}
            ></i>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                border: "1px solid black",
                padding: "10px 20px",
                margin: "2px",
              }}
            >
              <p style={{ padding: "10px 20px" }}>
                Refund of Amount Rs.{" "}
                {responseData?.amount &&
                  Number.parseFloat(responseData?.amount).toFixed(2)}{" "}
                has been{" "}
                {responseData?.refundStatus &&
                  getStatusMessage(responseData?.refundStatus)}
              </p>
              {responseData?.refundStatus == 100 && (
                <div>
                  {
                    <p style={{ padding: "10px 20px" }}>
                      Refund Transaction Date & Time:{" "}
                      {responseData?.bankTransactionDateTime &&
                        formatDate(responseData?.bankTransactionDateTime)}
                    </p>
                  }
                </div>
              )}
              <p style={{ padding: "10px 20px" }}>
                OEPSS Balance :
                <input
                  style={{ margin: "15px", "text-align": "center" }}
                  type="text"
                  id="balance"
                  name="balance"
                  // onChange={handleChange}
                  value={openingBalance}
                />{" "}
              </p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default RefundStatus;
